import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Global Components
// @ts-ignore
import ErrorGate from 'components/ErrorGate';
import FakeProgress from 'components/FakeProgress';

// Global Selectors
// HACK folder stucture
// @ts-ignore
import { makeSelectIncompleteContainerGroupValue } from 'scenes/Harvest/components/EventPrintDialog/components/EventIncompleteContainerGroupGate/selectors';

// Constants
const BUFFER = 3000;

interface OwnProps {
    harvestEventUuid: string;
}

interface ConnectedProps {
    requestedQuantity?: number;
}

type Props = OwnProps & ConnectedProps;

export class ContainerGroupProgress extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { requestedQuantity } = this.props;

        if (!requestedQuantity) {
            return null;
        }

        return (
            <ErrorGate namespace="CONTAINER_GROUP_LOAD">
                <FakeProgress
                    estimatedRequestTime={BUFFER + requestedQuantity * 28}
                />
            </ErrorGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    requestedQuantity: makeSelectIncompleteContainerGroupValue(
        'requestedQuantity'
    )
});

export default connect(mapStateToProps)(ContainerGroupProgress);
